import React, { Component } from 'react'
import FormViewer from './FormViewer'
import { nanoid } from 'nanoid'
import HttpServices from '../utils/Http.services'
import { checkTranslation, translate } from '../utils/useful'
import ItemModal from '../modals/ItemModal'
import ButtonAnimated from './buttons/ButtonAnimated'

export default class EditFields extends Component {

    state = {
        // initData: {}
        field: {}
    }

    componentDidMount() {
        // console.log('this.props.initData22d', this.props?.field)
        // console.log('this.props.initData22d', this.props?.initData)
        let field = this.props.field
        let initData = this.props?.initData

        field?.headers?.map((element) => {
            if (initData[element.key]) {

                element.information.defaultValue = initData[element.key]
                // console.log('elementelement',element)
            }
        })
        // console.log('fieldinit', field)
        // let initData = this.state.initData
        // initData.appletId = this.props.initData.applet
        // initData.appletHub = this.props.initData.appletHub
        this.createParams()

        this.setState({ field })

    }





    componentDidUpdate(prevProps) {
        // if (this.props.admins && JSON.stringify(this.props.admins) != JSON.stringify(prevProps.admins)) {
        //     this.init()
        // }
        if (prevProps.fields != this.props.fields) {
            this.createParams()
        }
    }


    createParams = () => {

        let params = []
        if (this.props.fields) {

            let myParams = { label: "Single Record", value: '*record', fields: JSON.parse(JSON.stringify(this.props.fields)), info: {} }


            let foundId = false

            for (let a = 0; a < myParams.fields.length; a++) {
                const element = myParams.fields[a];
                if (element?.key == '_id') {
                    foundId = true
                }
            }

            if (!foundId) {
                myParams.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                myParams.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                myParams.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
            }


            if (myParams) {
                params.splice(0, 0, myParams)
            }
        }


        this.setState({ params })
    }





    getForm = () => {
        // console.log('this.form.getForm()', form)
        // console.log('this.props.field.type', this.props.field)
        // if (this.props.field.type == 'LookupInput') {

        // }
        // return
        return this.form.getForm()

    }

    open = () => {
        this.itemModal.open()
    }


    close = () => {
        this.itemModal.close()
    }
    liveChange = (data) => {
        // console.log('datassss', data)
    }

    editField = () => {
        let data = {}
        data.field = { ...this.props.selectedField } ?? {}
        // console.log('data.field.key', data.field.key)
        // if (data.field.key?.includes('values.')) {
        //     console.log('has values')
        //     data.field.key = data.field.key.split('values.')[data.field.key.split('values.').length - 1]
        // }
        let information = this.form.getForm()
        console.log('informationobject', information)
        // return
        if (information) {
            Object.entries(information).map(([key, value]) => {
                data.field.information[key] = value
            })
            // console.log('data.field', data.field)
            this.props.setIsLoadingAddField(true)
            this.setState({ isLoading: true })
            this.props.editField(data, () => {
                this.setState({ isLoading: false })
            })
        }
    }

    render() {

        console.log(this.state.params)
        
        return (
            <div className=' scroll-no-scrollbar h-100 white-bg'>
                <div className='flexcb  position-sticky top-0 w-100 white-bg' style={{ padding: '6px 14px', zIndex: 2, borderBottom: '1px solid #eee' }}>
                    <div className='flexc' style={{}}>
                        <p className=' font-size-16  text-bold' >{translate('Edit Field')}</p>
                    </div>
                    <div className='flexc'>
                        <div className='px-1'>
                            <ButtonAnimated
                                // iconwidth='24px'
                                onClick={() => { this.props.closeFieldsData() }}
                                title={translate('Cancel')}
                                // icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor ?? '#000'}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background ?? '#eee'}
                            // isLoading={this.state.isLoading}
                            />
                        </div>
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => { !this.state.isLoading && this.editField() }}
                            title={translate('Submit')}
                            icon='/assets/icons/plus-white.svg'
                            textColor={this.props.colors?.textColor ?? '#000'}
                            invert={!this.props.colors?.iconInvert}
                            bg={this.props.colors?.background ?? '#eee'}
                            isLoading={this.state.isLoading}
                        />
                    </div>
                </div>
                {/* <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.page}
                    headers={this.props?.field?.headers}
                    pages={this.props.formPages}

                    initData={this.props.initData}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    width={this.props.width}
                    sideOpen={true}
                    // showDates={true}
                    submitForm={this.addField}
                    // functionsHandler={this.functionsHandler}
                    widthImport={300}
                // background={'linear-gradient(to right, rgb(77,46,229), rgb(77,46,229))'}
                // color={"rgb(77,46,229)"}
                /> */}


                <div className=''>
                    <div className='h-100 pb-5'>
                        {/* <div className='px-3  flexc py-3' style={{background:this.props.colors?.background}}>
                            <div className='br-4 ' style={{}}>
                                <p className='font-size-14 weight-500 ' style={{color:this.props.colors?.textColor }}>{translate("Field Type")} - {checkTranslation(this.props.field?.label)}</p>
                            </div>
                        </div> */}
                        {this.props.deleteHeader && (
                            <div className=' py-2 px-3 position-sticky' style={{ background: this.props.colors?.background, top: 0, zIndex: 10 }}>
                                <p className='main-c2 font-size-16 weight-500' style={{ color: this.props.colors?.textColor }}>{translate('Are you sure you want to delete?')}</p>
                            </div>
                        )}
                        <div className='mt-3'>
                            <FormViewer ref={el => this.form = el} liveChange={this.liveChange} headers={this.state?.field?.headers} formClass="bordered-form" inputClass={'bordered-input'} params={this.state.params} />
                        </div>
                    </div>
                    <div className='flexc w-100 px-2 py-2 position-sticky bg-white' style={{ justifyContent: 'flex-end', bottom: 0 }}>
                        {/* <div className='px-2'>
                            <ButtonAnimated
                                // iconwidth='24px'
                                onClick={() => { this.props.closeFieldsData() }}
                                title={translate('Cancel')}
                                // icon='/assets/icons/plus-white.svg'
                                textColor={'#777'}
                                invert={!this.props.colors?.iconInvert}
                                bg={'#eee'}
                            // isLoading={this.state.isLoading}
                            />
                        </div> */}
                        {this.props.deleteHeader && (
                            <ButtonAnimated
                                // iconwidth='24px'
                                // onClick={() => { !this.state.isLoading && this.addField() }}
                                title={translate('Delete')}
                                // icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background}
                                isLoading={this.state.isLoading}
                            />
                        )}
                        {this.props.editHeader && (
                            <ButtonAnimated
                                iconwidth='24px'
                                // onClick={() => { !this.state.isLoading && this.addField() }}
                                title={translate('Submit')}
                                icon='/assets/icons/arrow-right-white.svg'
                                textColor={this.props.colors?.textColor}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background}
                                isLoading={this.state.isLoading}
                            />
                        )}
                    </div>
                    {/* <div className='flexc  py-2 w-100' style={{ position: "fixed", bottom: 0, zIndex: 10 }}>
                        <button className='gray-btn w-100 mx-2 py-2 br-5'>
                            <p className='main-c5'>{translate('Discard')}</p>
                        </button>
                        <button className='purple-btn w-100 mx-2 py-2 br-5' onClick={() => this.addField()}>
                            <p>{translate('Submit')}</p>
                        </button>
                    </div> */}
                </div>
            </div>
        )
    }
}
